// Recent work resources — CLIENT-SIDE ONLY (localStorage). Never sent to a server:
// KaziPeople does not keep a centralized browsing history. Per-viewer convenience.
import type { RecentResource } from './types';

const KEY = 'kp-web-recents';
const MAX = 12;

export function loadRecents(): RecentResource[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecent(r: RecentResource): RecentResource[] {
  try {
    const existing = loadRecents().filter((x) => x.url !== r.url);
    const next = [{ ...r, lastAccess: Date.now() }, ...existing].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch {
    return loadRecents();
  }
}

export function clearRecents(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
